import {validateMaxLength} from '../../common/validationUtils';
import {messages} from '../common/Translations';
import {plainJSTranslator} from "../../common/PlainJSTranslator";


export const validate = values => {
    let errors = {};

    if (!values.title) {
        errors.title = plainJSTranslator.formatMessage(messages.required);
    }

    if (!values.description) {
        errors.description = plainJSTranslator.formatMessage(messages.required);
    }

    errors = validateMaxLength({values, errors, length: 255, fields: [
        'title',
        'description',
    ]});

    return errors;
};


// WEBPACK FOOTER //
// ./web/src/components/tips/validate.js